"use client";
import { jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { INVALID_PROPS_ERROR, COMPONENT_NAME } from "./types.js";
import { PillBadgesList } from "./view.pillbadgesList.js";
import { PillBadgesContainer } from "./styles.js";
const PillBadges = (props) => {
  const { pillBadges, uniqueId, sx } = props || {};
  if (!pillBadges || !Array.isArray(pillBadges) || !pillBadges.length) {
    console.error(INVALID_PROPS_ERROR);
    return null;
  }
  if (pillBadges.length === 1) {
    return /* @__PURE__ */ jsx(Box, { sx, children: /* @__PURE__ */ jsx(PillBadgesList, { ...props, componentType: "div" }) });
  }
  return /* @__PURE__ */ jsx(
    PillBadgesContainer,
    {
      "data-testid": `${COMPONENT_NAME}_${uniqueId}`,
      sx,
      children: /* @__PURE__ */ jsx(PillBadgesList, { ...props, componentType: "li" })
    }
  );
};
PillBadges.displayName = "PillBadges";
export {
  PillBadges
};
